import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Account = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.832 10.25h7.336l.151.071a13.996 13.996 0 0 1 4.604 3.532c1.166 1.376 1.994 2.964 1.994 4.41 0 1.275-.504 2.15-1.184 2.734-.645.552-1.411.808-1.882.958-1.794.572-4.562.809-7.26.794-2.704-.014-5.462-.283-7.251-.787-.501-.14-1.268-.399-1.914-.96-.677-.59-1.176-1.472-1.176-2.739 0-1.434.776-3.017 1.906-4.4a13.301 13.301 0 0 1 4.524-3.541l.152-.072ZM12.725 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
    <Path
      d="M11.589 12.298a5.15 5.15 0 1 0 0-10.298 5.15 5.15 0 0 0 0 10.298Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </Icon>
);

export default Account;
